import React, { useState } from "react";

import * as s from "./formsection.module.css";

interface FormSectionProps {
  title: string;
  borderBottomWidth?: number;
  fontSizeClass?: number;
}

const FormSection: React.FC<FormSectionProps> = ({
  children,
  title,
  borderBottomWidth,
  fontSizeClass,
}) => {
  const [depsOpen, setDepsOpen] = useState(true);
  return (
    <>
      <div>
        <p
          className={`fw-bold text-dark-light mb-2 ' ${
            fontSizeClass || "fs-22px "
          }`}
        >
          {title}
        </p>
        <p
          className="border-bottom mb-2"
          style={{ width: borderBottomWidth || 50 }}
        >
          {" "}
        </p>
      </div>

      <div className={`${s.inputContainer} ${depsOpen ? s.slide : ""}`}>
        {children}
      </div>
    </>
  );
};

export { FormSection };
